export default __webpack_public_path__ + "static/media/028.ab6e5a06.jpg";